var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "14px",
    viewBox: "0 0 9 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Drag icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-2---Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.2.2--Drag-and-reorder",
    transform: "translate(-96.000000, -403.000000)",
    fill: "#969696",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document-sections-side-bar",
    transform: "translate(64.000000, 127.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sections-side-bar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup",
    transform: "translate(0.000000, 83.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drag-icon",
    transform: "translate(8.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more-vertical-outline"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.55555556,
    cy: 7,
    r: 1.55555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.55555556,
    cy: 1.55555556,
    r: 1.55555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.55555556,
    cy: 12.4444444,
    r: 1.55555556
  })), /*#__PURE__*/React.createElement("g", {
    id: "more-vertical-outline",
    transform: "translate(5.444444, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.55555556,
    cy: 7,
    r: 1.55555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.55555556,
    cy: 1.55555556,
    r: 1.55555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.55555556,
    cy: 12.4444444,
    r: 1.55555556
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/Drag.88bf5c883f2b85f761a9365db9c583c8.svg";
export { ForwardRef as ReactComponent };